module.exports = __webpack_public_path__ + "img/vtta-plomberie.6334b41c.png";